"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrashCanIcon16Solid = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var BaseIcon_1 = require("../../internal/BaseIcon");
exports.TrashCanIcon16Solid = forwardRef_1.forwardRef('TrashCanIcon16Solid', function (props, ref) {
    return (react_1.default.createElement(BaseIcon_1.BaseIcon, tslib_1.__assign({ ref: ref, viewBoxSize: 16 }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.25 3.25v-1a2 2 0 0 1 2-2h3.5a2 2 0 0 1 2 2v1h2.5a.75.75 0 0 1 0 1.5h-.568l-.8 8.181c-.116 1.176-1.083 2.07-2.24 2.07H5.357c-1.155 0-2.123-.894-2.238-2.07l-.8-8.181h-.57a.75.75 0 0 1 0-1.5H4.25Zm1.5-1a.5.5 0 0 1 .5-.5h3.5a.5.5 0 0 1 .5.5v1h-4.5v-1Zm.75 3.625c.345 0 .625.28.625.625v5a.625.625 0 1 1-1.25 0v-5c0-.345.28-.625.625-.625Zm3.625.625a.625.625 0 1 0-1.25 0v5a.625.625 0 1 0 1.25 0v-5Z" })));
});
